export default __webpack_public_path__ + "static/media/oh-yeah-dance.74661ef9.gif";